// extracted by mini-css-extract-plugin
export default {"sectionTitle":"d47f301f"};